export const downloadFile = (url, fileName) => {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_self';
    a.download = fileName || '';
    a.click();
    a.remove();
}

export function downloadBlob(blob, fileName) {
	const url = window.URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = fileName || true;
	a.click();
	a.remove();
}